<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>

            <v-card class="box no-display">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Employee Salary Summary Report</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center">
                    <v-col cols="12" sm="3" md="3">
                        <p class="pl-2 mb-2"><b>Salary Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="year_list"
                            @change="getSalaryMonth();" item-text="name" item-value="id" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="ay">
                        <p class="pl-2 mb-2"><b>Salary Month</b>&nbsp;<span style="color: red">*</span></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="sal_month"
                            :items="sal_month_list" item-text="sal_mon" item-value="id" return-object outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p class="pl-2 mb-2"><b>Employee Type</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="employee_type"
                            @change="getSections" :items="employee_type_list" item-text="name" item-value="id"
                            outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p class="pl-2 mb-2"><b>Employee Section</b>&nbsp;<span style="color: red">*</span></p>
                        <v-select rounded required v-model="section" :items="section_list" item-text="name" dense
                            item-value="id" outlined multiple @change="getEmployeeFromSection()" :loading="emp_loading">

                            <template v-slot:prepend-item>
                                <v-list-item @mousedown.prevent>
                                    <v-list-item-action>
                                        <v-checkbox v-model="selected_all_section" @change="toggle_section()">
                                            <template #label><span class="ml-8">Select All</span>
                                            </template>
                                        </v-checkbox>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="section">
                        <p class="pl-2 mb-2"><b>Report Type</b>&nbsp;<span style="color: red">*</span></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="report_type"
                            :items="report_type_list" item-text="name" item-value="id" outlined 
                            @change="clearReportData" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="section">
                        <p class="pl-2 mb-2"><b>Employee</b>&nbsp;<span style="color: red">*</span></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="employee" :items="employee_list"
                            item-text="name" item-value="id" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="sal_month && section" style="align-content: center;">
                        <v-btn class="button" :loading="loader" @click="
                            fetchEmployeeSalarySummaryReport();
                        ">
                            Fetch Report
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="box" v-if="emp_salary_reg_detail.length > 0">
                <v-row dense class="no-display" justify="end">
                    <v-btn rounded color="success" outlined class="ma-2 no-display" @click="
                        fnExcelReport('my-table-id', 'EmployeeSalarySummaryReport')
                        ">
                        <v-icon color="success">mdi-export</v-icon>Export
                    </v-btn>
                    <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print"> <v-icon
                            left>mdi-printer</v-icon>
                        Print <v-icon right></v-icon> </v-btn>
                </v-row>
                <div id="my-table-id">
                    <!-- TABLE 1: ESIC REPORT TABLE -->
                    <v-simple-table v-if="report_type === 'ESIC'" fixed-header dense class="elevation-1 payroll-table">
                        <thead class="last-row">
                            <tr class="first-row" style="height: 100px; line-height: 100%;">
                                <td style="padding-top: 30px !important; padding-bottom: 20px;" class="text-center" colspan="6">
                                    <h1>{{ org_basic_data.trust_name }}</h1>
                                    <br>
                                    <h2>{{ org_basic_data.school_name }}</h2> <br>
                                    <h3>ESIC Report For <span class="indigo--text">{{ sal_month.sal_mon }}</span> </h3>
                                </td>
                            </tr>
                            <tr style="background-color: grey; color: white;">
                                <td class="text-center">Sr.No.</td>
                                <td class="text-center">Employee Code</td>
                                <td class="text-center">Employee Name</td>
                                <td class="text-center">Section</td>
                                <td class="text-center">Gross Salary</td>
                                <td class="text-center">ESIC</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(s, index) in emp_salary_reg_detail" :key="'esic-row-' + index">
                                <td class="text-center">{{ index + 1 }}</td>
                                <td>{{ s.emp_code }}</td>
                                <td>{{ s.emp_name }}</td>
                                <td>{{ s.emp_section }}</td>
                                <td>{{ s.gross_salary }}</td>
                                <td class="text-center">
                                    {{ getEsicValue(s.comp_value_dedu) }}
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>

                    <!-- TABLE 2: PF / DEFAULT SALARY SUMMARY REPORT TABLE -->
                    <v-simple-table v-else fixed-header dense class="elevation-1 payroll-table">
                        <thead class="last-row">
                            <tr class="first-row" style="height: 100px; line-height: 100%;">
                                <td style="padding-top: 30px !important; padding-bottom: 20px;" class="text-center"
                                    :colspan="(pfac ? 5 : 3) + filteredEarnHeaders.length + filteredDeduHeaders.length + 1">
                                    <h1>{{ org_basic_data.trust_name }}</h1>
                                    <br>
                                    <h2>{{ org_basic_data.school_name }}</h2> <br>
                                    <h3>Salary For <span class="indigo--text">{{ sal_month.sal_mon }}</span> </h3>
                                </td>
                            </tr>
                            <tr style="background-color: grey; color: white;">
                                <td class="text-center">Sr.No.</td>
                                <td class="text-center">Employee Code</td>
                                <td class="text-center">Employee Name</td>
                                <td class="text-center" v-if="pfac">PF No.</td>
                                <td class="text-center" v-if="pfac">UAN No.</td> 
                                <td class="text-center" v-for="(earnheader, i) in filteredEarnHeaders" :key="'pf-earn-hdr-' + i">
                                    {{ earnheader }}
                                </td>
                                <td class="text-center">Gross Salary</td>
                                <td class="text-center" v-for="(deduheader, k) in filteredDeduHeaders" :key="'pf-dedu-hdr-' + k">
                                    {{ deduheader }}
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(s, index) in emp_salary_reg_detail" :key="'pf-row-' + index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ s.emp_code }}</td>
                                <td>{{ s.emp_name }}</td>
                                <td v-if="pfac">{{ s.emp_pf_no }}</td>
                                <td v-if="pfac">{{ s.emp_uan_no }}</td>
                                <td class="text-center" v-for="(earnvalue, i) in getFilteredValueEarn(s.comp_value_earn)" :key="'pf-earn-val-' + index + '-' + (earnvalue.emp_sd_id || i)">
                                    {{ earnvalue.s_value }}
                                </td>
                                <td>{{ s.gross_salary }}</td>
                                <td class="text-center" v-for="(deduvalue, k) in getFilteredValueDedu(s.comp_value_dedu)" :key="'pf-dedu-val-' + index + '-' + (deduvalue.emp_sd_id || k)">
                                    {{ deduvalue.s_value }}
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
            </v-card>
        </v-container>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        acno: true,
        designation_show: true,
        purpose: true,
        breadcrumbClass: "breadcrumb-style1",
        section_show: true,
        pfac: true,
        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        title: "",
        sal_month_list: [],
        employee_type_list: [],
        employee_list: [],
        sal_month: null,
        inst_list: null,
        employee_type: null,
        employee: null,
        ay: null,
        comp_header_earn: [],
        comp_header_dedu: [],
        emp_salary_reg_detail: [],
        overlay: false,
        search: null,
        section_list: null,
        section: null,
        emp_loading: false,
        selected_all_section: false,
        year_list: [],
        org_basic_data: null,
        report_type: null,
        report_type_list: [
            { id: "PF", name: "PF report" },
            { id: "ESIC", name: "Esic report" }
        ],
    }),
    computed: {
        filteredEarnHeaders() {
            if (!this.comp_header_earn) return [];
            return this.comp_header_earn;
        },
        filteredDeduHeaders() {
            if (!this.comp_header_dedu) return [];
            if (this.report_type === 'PF') {
                return this.comp_header_dedu.filter(
                    hdr => !hdr.toUpperCase().includes("ESIC") && !hdr.toUpperCase().includes("E.S.I.C.")
                );
            }
            return this.comp_header_dedu;
        }
    },
    methods: {
        getFilteredValueEarn(compValues) {
            if (!compValues || !Array.isArray(compValues)) return [];
            return compValues;
        },
        getFilteredValueDedu(compValues) {
            if (!compValues || !Array.isArray(compValues)) return [];
            // Filter out ESIC values when report_type is 'PF'
            if (this.report_type === 'PF') {
                return compValues.filter(
                    item => !item.s_name || (!item.s_name.toUpperCase().includes("ESIC") && !item.s_name.toUpperCase().includes("E.S.I.C."))
                );
            }
            return compValues;
        },
        getEsicValue(deductions) {
            if (!deductions || !Array.isArray(deductions)) return 0;
            const esicObj = deductions.find(
                item => item.s_name && (item.s_name.toUpperCase().includes("ESIC") || item.s_name.toUpperCase().includes("E.S.I.C."))
            );
            return esicObj ? esicObj.s_value : 0;
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            // var blob = new Blob([tab_text], {
            //     type: "application/vnd.ms-excel;charset=utf-8",
            // });
            // window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        getSalaryMonth() {
            this.sal_month = "";
            const data = {
                year: this.ay,
            };
            axios
                .post("/Payroll/getSalaryMonth", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.sal_month_list = res.data.sal_month_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => { });
        },
        toggle_section() {
            this.$nextTick().then(() => {
                if (this.selected_all_section) {
                    this.section = [];
                    for (var x in this.section_list) {
                        this.section.push(this.section_list[x].id);
                    }
                    this.getEmployeeFromSection();
                } else {
                    this.section = [];
                }
            });
        },
        getEmployeeFromSection() {
            if (this.section.length == 0) {
                this.employee_list = [];
                return;
            }
            const data = {
                section_ids: this.section,
            };
            this.emp_loading = true;
            axios.post("/Payroll/getEmployeeByEmpSection", data).then((res) => {
                if (res.data.flag == "YES") {
                    this.employee_list = res.data.employee_list;
                    this.emp_loading = false;
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    this.emp_loading = false;
                }
            });
        },
        fetchEmployeeSalarySummaryReport() {
            this.emp_salary_reg_detail = [];
            const data = {
                section_ids: this.section,
                employee: this.employee,
                sal_month: this.sal_month.id,
                report_type: this.report_type,
            };
            this.loader = true;
            axios.post("/Payroll/fetchEmployeeSalarySummaryReport", data).then((res) => {
                if (res.data.flag == "YES") {
                    this.comp_header_dedu = res.data.comp_header_dedu;
                    this.org_basic_data = res.data.org_basic_data;
                    this.emp_salary_reg_detail = res.data.emp_salary_reg_detail;
                    this.comp_header_earn = res.data.comp_header_earn;
                    this.loader = false;
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    this.loader = false;
                }
            });
        },
        getSections() {
            const data = {
                empType: this.employee_type,
            };
            axios
                .post("/Payroll/getEmpSectionByEmpType", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.section_list = res.data.section_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => { });
        },
        onLoad() {
            axios
                .post("/Payroll/getYear")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.employee_type_list = res.data.employee_type_list;
                        this.year_list = res.data.year_list;
                        this.section_list = res.data.section_list.filter(item => item.name !== 'All');
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => { });
        },
        clearReportData() {
            this.emp_salary_reg_detail = [];
            this.comp_header_earn = [];
            this.comp_header_dedu = [];
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onLoad();
    },
};
</script>

<style scoped>
thead {
    font-weight: bold !important;
}

td {
    border: 1px solid black;
    font-size: small;
}

tbody {
    font-size: small;
}

td {
    font-size: small;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

v-simple-table {
    white-space: nowrap !important;
    font-size: small;
}

.last-row {
    font-weight: 800 !important;
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    table,
    td,
    tr {
        break-inside: avoid-page;
    }

    body,
    td,
    center {
        font-size: 14pt !important;
    }

    .last-row {
        font-size: 14pt !important;
    }

    .payroll-table {
        width: 100% !important;
        max-width: 100% !important;
        table-layout: fixed !important;
        overflow-x: hidden !important;
    }

    .first-row {
        line-height: 170% !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    v-card {
        border: none !important;
    }

    @page {
        margin: 0;
        size: 34in 23in;
    }

    .box {
        overflow-x: hidden;
        border: none !important;
    }
}
</style>